import { MapPin, Phone, MessageCircle, Clock, Navigation } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SITE } from "../config/site";

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Overline>Find Us</Overline>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl font-bold text-brand-ink tracking-tight leading-tight">
            Right around
            <span className="italic text-brand-green"> the corner.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-8 items-stretch">
          <Reveal>
            <div className="h-full bg-white rounded-[2rem] shadow-soft p-8 sm:p-10 flex flex-col gap-7">
              <div className="flex gap-4">
                <span className="w-12 h-12 shrink-0 rounded-2xl bg-brand-green/5 border border-brand-green/10 flex items-center justify-center">
                  <MapPin size={20} className="text-brand-green" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-brand-ink">Address</h3>
                  <p data-testid="contact-address" className="mt-1 text-brand-mute text-sm sm:text-base leading-relaxed">
                    {SITE.address}
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="w-12 h-12 shrink-0 rounded-2xl bg-brand-green/5 border border-brand-green/10 flex items-center justify-center">
                  <Phone size={20} className="text-brand-green" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-brand-ink">Phone</h3>
                  <a
                    data-testid="contact-phone-link"
                    href={SITE.phoneHref}
                    className="mt-1 inline-block text-brand-mute text-sm sm:text-base hover:text-brand-green transition-colors"
                  >
                    {SITE.phoneDisplay}
                  </a>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="w-12 h-12 shrink-0 rounded-2xl bg-brand-green/5 border border-brand-green/10 flex items-center justify-center">
                  <Clock size={20} className="text-brand-green" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-brand-ink">Business Hours</h3>
                  <p data-testid="contact-hours" className="mt-1 text-brand-mute text-sm sm:text-base">
                    {SITE.hours}
                  </p>
                </div>
              </div>
              <div className="mt-auto pt-4 flex flex-wrap gap-3">
                <a
                  data-testid="contact-directions-button"
                  href={SITE.directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-brand-green px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-brand-deep hover:scale-[1.03]"
                >
                  <Navigation size={16} aria-hidden="true" />
                  Get Directions
                </a>
                <a
                  data-testid="contact-call-button"
                  href={SITE.phoneHref}
                  className="inline-flex items-center gap-2 rounded-full border border-brand-green px-6 py-3.5 text-sm font-semibold text-brand-green transition-colors duration-300 hover:bg-brand-green hover:text-white"
                >
                  <Phone size={16} aria-hidden="true" />
                  Call Now
                </a>
                <a
                  data-testid="contact-whatsapp-button"
                  href={SITE.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-brand-green px-6 py-3.5 text-sm font-semibold text-brand-green transition-colors duration-300 hover:bg-brand-green hover:text-white"
                >
                  <MessageCircle size={16} aria-hidden="true" />
                  WhatsApp
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="h-full min-h-[24rem] rounded-[2rem] overflow-hidden shadow-soft border border-brand-green/10">
              <iframe
                data-testid="contact-map"
                title="Lagom Unisex Salon, Electronic City on Google Maps"
                src={SITE.mapEmbed}
                className="w-full h-full min-h-[24rem]"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
